var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "12px",
    viewBox: "0 0 17 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D0E4DF2A-5A97-4B68-8137-524676195E3F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 11.3498888 0 11.3498888 6.96107556 0 6.96107556"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 7.50383548 0 7.50383548 7.34708813 0 7.34708813"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clients-View-/-Payment-invoice-create",
    transform: "translate(-1348.000000, -362.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(1342.000000, 358.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(6.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 4.269484)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1413453,4.63830951 C4.52987986,4.63830951 4.91848858,4.64041502 5.30702314,4.63772868 C5.66507713,4.63518753 5.93309849,4.38506659 5.93436314,4.05820318 C5.93554583,3.73242882 5.66581875,3.47744341 5.30932216,3.47642695 C4.53840848,3.47410362 3.76749481,3.47410362 2.99658113,3.47635435 C2.63340997,3.4773708 2.37777366,3.71986832 2.3773279,4.05529901 C2.37680955,4.39145575 2.63214921,4.63504233 2.99420795,4.63765607 C3.37658707,4.64048763 3.75896618,4.63830951 4.1413453,4.63830951 M0.00510975971,0 L11.3498888,0 C10.0023658,0.667448999 9.12725452,1.6812193 8.80961881,3.09750643 C8.49131563,4.51647992 8.84047019,5.79932081 9.78373628,6.95016755 C9.7123183,6.95445119 9.66062741,6.96018691 9.60893652,6.96025952 C7.13778552,6.96069514 4.66663453,6.96200201 2.1955577,6.9599691 C0.987162563,6.95895264 0.0237985761,6.06084059 0.00993028775,4.8821865 C-0.00912933848,3.26180939 0.00510975971,1.64099666 0.00510975971,0",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.4491175,3.09332038 L0.00281073865,3.09332038 C0.00281073865,2.77756538 -0.00104568377,2.46602142 0.00355235835,2.15462267 C0.0195713438,1.05844677 0.726557401,0.233519597 1.82645357,0.0326242007 C1.97077277,0.00626893184 2.12161821,0.00684976422 2.26942302,0.00677716017 C5.89698161,0.00547028733 9.52461436,0.0157074579 13.1521729,0 C14.3008677,-0.00498469536 15.2023064,0.743998648 15.367836,1.70592966 C15.4455577,2.15788985 15.4248665,2.62611334 15.4491175,3.09332038",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(9.496165, 4.652912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15818879,4.25488905 C3.15818879,4.5697002 3.15744717,4.86447262 3.15841127,5.15924505 C3.15959787,5.53772995 3.41122943,5.80941429 3.7558601,5.80582003 C4.1037539,5.80215388 4.34463198,5.53584224 4.34567025,5.15191204 C4.34648603,4.85779305 4.34589273,4.56367406 4.34589273,4.25496165 C4.54435016,4.25496165 4.72211641,4.25496165 4.89988265,4.25496165 C5.64105737,4.25496165 5.9342938,4.08811756 5.92984408,3.66919221 C5.92539437,3.25353404 5.64001911,3.09220785 4.90944954,3.09220785 C4.72626948,3.09220785 4.54308941,3.09220785 4.34589273,3.09220785 L4.34589273,2.56720799 C4.34589273,1.82301651 4.17828668,1.53594011 3.74703483,1.54116761 C3.31800783,1.54632249 3.15818879,1.82221787 3.15818879,2.55776946 L3.15818879,3.07020882 C3.12622498,3.08168026 3.11524901,3.08901327 3.10419887,3.08908588 C2.8016922,3.09061056 2.49918553,3.0895941 2.19675301,3.09271608 C1.83773492,3.09641888 1.57141928,3.34777409 1.57392303,3.67652522 C1.5764623,4.00324342 1.84529944,4.25162187 2.20416921,4.25438082 C2.51253468,4.25677676 2.82090015,4.25488905 3.15818879,4.25488905 M3.7543027,7.34709656 C1.67294702,7.34869268 0.00178119394,5.71437559 3.6173087e-13,3.67572657 C-0.00170441863,1.63751318 1.66679158,0.00181661294 3.74933385,-4.2597037e-12 C5.83217277,-0.00181358938 7.50222617,1.63105142 7.50385892,3.6708621 C7.50548929,5.70965633 5.83706746,7.3454981 3.7543027,7.34709656",
    id: "Fill-6",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default ForwardRef;